/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Digital_DownloadInputs */

const en_fulfillment_digital_download = /** @type {(inputs: Fulfillment_Digital_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital Download`)
};

const es_fulfillment_digital_download = /** @type {(inputs: Fulfillment_Digital_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga digital`)
};

const fr_fulfillment_digital_download = /** @type {(inputs: Fulfillment_Digital_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargement numérique`)
};

const de_fulfillment_digital_download = /** @type {(inputs: Fulfillment_Digital_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digitaler Download`)
};

const ja_fulfillment_digital_download = /** @type {(inputs: Fulfillment_Digital_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デジタルダウンロード`)
};

const zh_fulfillment_digital_download = /** @type {(inputs: Fulfillment_Digital_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字下载`)
};

const ar_fulfillment_digital_download = /** @type {(inputs: Fulfillment_Digital_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنزيل رقمي`)
};

const id_fulfillment_digital_download = /** @type {(inputs: Fulfillment_Digital_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduhan Digital`)
};

const it_fulfillment_digital_download = /** @type {(inputs: Fulfillment_Digital_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Digitale`)
};

const ru_fulfillment_digital_download = /** @type {(inputs: Fulfillment_Digital_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цифровая загрузка`)
};

const pt_fulfillment_digital_download = /** @type {(inputs: Fulfillment_Digital_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Digital`)
};

const ko_fulfillment_digital_download = /** @type {(inputs: Fulfillment_Digital_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디지털 다운로드`)
};

/**
* | output |
* | --- |
* | "Digital Download" |
*
* @param {Fulfillment_Digital_DownloadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfillment_digital_download = /** @type {((inputs?: Fulfillment_Digital_DownloadInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Digital_DownloadInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfillment_digital_download(inputs)
	if (locale === "es") return es_fulfillment_digital_download(inputs)
	if (locale === "fr") return fr_fulfillment_digital_download(inputs)
	if (locale === "de") return de_fulfillment_digital_download(inputs)
	if (locale === "ja") return ja_fulfillment_digital_download(inputs)
	if (locale === "zh") return zh_fulfillment_digital_download(inputs)
	if (locale === "ar") return ar_fulfillment_digital_download(inputs)
	if (locale === "id") return id_fulfillment_digital_download(inputs)
	if (locale === "it") return it_fulfillment_digital_download(inputs)
	if (locale === "ru") return ru_fulfillment_digital_download(inputs)
	if (locale === "pt") return pt_fulfillment_digital_download(inputs)
	return ko_fulfillment_digital_download(inputs)
});